import { AxiosService } from './';

const getUserList = async (
  _perPage,
  _page,
  commonSearch,
  sortBy,
  role,
  hasInvested,
) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/users',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        commonSearch: commonSearch,
        sortBy: sortBy,
        role: role,
        hasInvested: hasInvested,
      },
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const getUserDetails = async (_userId) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/users/' + _userId,
      isAuthorized: true,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

//active /Inactive users
const updateUser = async (_formData) => {
  try {
    let axiosData = {
      method: 'put',
      url: 'admin/users',
      isAuthorized: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const documentApproveRejectStatus = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/users/documentApproveReject',
      isAuthorized: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const makeUserAdmin = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/users/make_user_admin',
      isAuthorized: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const updateKycStatus = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/users/update_kyc_status',
      isAuthorized: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const generateKycLink = async (userId) => {
  try {
    let axiosData = {
      method: 'get',
      url: `admin/kyc/users/${userId}/generate-kyc-link`,
      isAuthorized: true,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message || 'Failed to generate KYC link');
  }
};
const resetApplicant = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: `admin/kyc/reset-applicant`,
      isAuthorized: true,
      formData: _formData,
    };

    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message || 'Failed to reset applicant');
  }
};

export {
  getUserList,
  getUserDetails,
  updateUser,
  documentApproveRejectStatus,
  makeUserAdmin,
  updateKycStatus,
  generateKycLink,
  resetApplicant,
};
